/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量11
 * @export
 * @interface Col11
 */
export interface Col11 {
}

/**
 * Check if a given object implements the Col11 interface.
 */
export function instanceOfCol11(value: object): value is Col11 {
    return true;
}

export function Col11FromJSON(json: any): Col11 {
    return Col11FromJSONTyped(json, false);
}

export function Col11FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col11 {
    return json;
}

export function Col11ToJSON(json: any): Col11 {
    return Col11ToJSONTyped(json, false);
}

export function Col11ToJSONTyped(value?: Col11 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

